import m from "../../geodata/es2015/worldLow";
window.am4geodata_worldLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/worldLow.js
// module id = null
// module chunks = 